import React, { useEffect, useState } from 'react'
import LoadSpinner from '../../../components/load-spinner/LoadSpinner';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from '../../../components/custom-table/CustomTable';
import { faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import { setSelectedTag, setShowEditTagUserModal } from '../../../slice/editTagSlice';
import { setShowCreateTagUserModal } from '../../../slice/showModalSlice';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateUserTag from '../../../components/modals/create-user-tag/CreateUserTag';
import useTag from '../../../hooks/useTag';
import { toast } from 'react-toastify';
import EditUserTag from '../../../components/modals/edit-user-tag/EditUserTag';
import { privileges } from '../../../config/role';

const DashboardUserTags = () => {
    // const { getLabel } = useLabel()
    const [labels,setLabels] = useState([]);

    const dispatch = useDispatch();
    const showCreateModal = useSelector((state)=>state.showModal.showCreateTagUserModal);
    const userRole = useSelector((state)=> state.user.role);
    const authorized = privileges.editingUserTags.includes(userRole);
    const { getUserTags, tagLoading } = useTag();

    useEffect(()=>{
        getLabelsData();
    },[])

    const getLabelsData = () => {
      getUserTags(
        (data)=>{
            setLabels(data.content)
        },
        ()=>{
          toast.error("Errore nel ricevere i tag porte")
        },
        false
      )
    }


    const headerTable = [
            { label: "Nome", field: "name", width: 270 },
            { label: "Tipo", field: "type", width: 270 },
            { label: "Colore", field: "palette", width: 270 },
        ];
    
      const dataForTable = (labels || []).map((label) => ({
        ...label,
        clickEvent: () => {
          dispatch(setSelectedTag(label));
          dispatch(setShowEditTagUserModal())
        },
        palette: <div className='ms-auto me-auto' style={{backgroundColor:`${label.color}`,width:"25px", height:"25px", borderRadius:"50%"}}></div>
      }));
    
      const createNewTag = () => {
        dispatch(setShowCreateTagUserModal());
      }


  return (
    <>
      <div className="container-fluid">
        <div className='row px-3'>
          <div className="d-flex align-items-center justify-content-between mb-4 px-1">
            <h1 className="h1 mb-2 text-primary-custom">Dashboard Gruppi</h1>
             {authorized &&<Button className='btn-custom btn-green' onClick={createNewTag}>
              <FontAwesomeIcon icon={faPlus}/> Aggiungi
            </Button>}
          </div>
        </div>
        <div className="row mb-3">
          {tagLoading
          ?<LoadSpinner/>
          :<CustomTable
            clickIcon={faMagnifyingGlass}
            header={headerTable}
            data={dataForTable}
            checkable={false}
            label='Gruppi'/>
          }
        </div>
      </div>
      {showCreateModal && <CreateUserTag onSuccess={getLabelsData} />}
      <EditUserTag onSuccess={getLabelsData} />
    </>
  );
}

export default DashboardUserTags